
import { Model } from "@vuex-orm/core";
import { Component } from "./Specialty";

export class TrainningLogbook extends Model {
  static entity = "trainningLogbooks";

  static fields() {
    return {
      id: this.attr(null),
      label: this.attr(''),
      type: this.attr(''), // unused... remove
      components: this.belongsToMany(Component, TrainningLogbookComponent, 'logbook', 'component'),
    };
  }
}

// Remove? unused
export class TrainningLogbookComponent extends Model {
  static entity = 'trainningLogbookComponents'
  static primaryKey = ['logbook', 'component']

  static fields() {
    return {
      logbook: this.attr(null),
      component: this.attr(null)
    }
  }
}